import React from "react";
import { SectionHeader } from "./DecisionModalHelpers";

const ProposalOption = ({
  proposal,
  isSelected,
  onClick,
  label,
  activeColor = "#2563eb",
  activeBg = "linear-gradient(135deg, #eff6ff, #dbeafe)",
}) => (
  <div
    onClick={onClick}
    className="p-3 rounded d-flex align-items-start"
    style={{
      border: isSelected ? `2px solid ${activeColor}` : "1px solid #e2e8f0",
      background: isSelected ? activeBg : "#fff",
      cursor: "pointer",
      transition: "all 0.15s ease",
      gap: 12,
    }}
  >
    <div
      className="d-flex align-items-center justify-content-center flex-shrink-0"
      style={{
        width: 24,
        height: 24,
        borderRadius: "50%",
        marginTop: 2,
        background: isSelected ? activeColor : "#e2e8f0",
        transition: "all 0.15s ease",
      }}
    >
      {isSelected && (
        <i className="fa fa-check" style={{ fontSize: 12, color: "#fff" }} />
      )}
    </div>
    <div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 700,
          color: "#1e293b",
        }}
      >
        {label}
      </div>
      {proposal.description && (
        <div style={{ fontSize: 13, color: "#64748b", marginTop: 2 }}>
          {proposal.description}
        </div>
      )}
    </div>
  </div>
);

const DecisionModalDecision = ({
  inscription,
  readOnly,
  isSuppression,
  selectedProposalId,
  isNoSanction,
  radiationBRSA,
  setRadiationBRSA,
  radiationDE,
  setRadiationDE,
  note,
  setNote,
  onSelectProposal,
  ruProposal,
  alternativeProposal,
  noSanctionProposal,
  loadingBareme,
  baremeError,
}) => {
  return (
    <div className="col-12 col-lg-7 p-4">
      {!readOnly ? (
        <>
          {/* Sélection sanction */}
          <SectionHeader
            icon="fa-gavel"
            iconBg="#22c55e"
            title="Décision de l'EP"
            subtitle="Sélectionnez la sanction à appliquer"
          />

          {loadingBareme ? (
            <div
              className="d-flex align-items-center justify-content-center p-4 mb-4 rounded"
              style={{
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                gap: 10,
              }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 16, color: "#64748b" }}
              />
              <span style={{ fontSize: 14, color: "#64748b" }}>
                Chargement des propositions de sanction...
              </span>
            </div>
          ) : baremeError ? (
            <div
              className="d-flex align-items-center p-3 mb-4 rounded"
              style={{
                border: "1px solid #fde68a",
                background: "#fefce8",
                gap: 10,
              }}
            >
              <i
                className="fa fa-exclamation-triangle"
                style={{ fontSize: 14, color: "#92400e" }}
              />
              <span style={{ fontSize: 13, color: "#92400e" }}>
                {baremeError}
              </span>
            </div>
          ) : (
            <div className="d-flex flex-column mb-4" style={{ gap: 10 }}>
              {/* Proposition du RU */}
              {ruProposal && (
                <ProposalOption
                  proposal={ruProposal}
                  isSelected={selectedProposalId === ruProposal.id}
                  onClick={() => onSelectProposal(ruProposal)}
                  label={
                    <>
                      Sanction{" "}
                      {ruProposal.id === "DEFAUT" ? "par défaut" : "modérée"}
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: "#3b82f6",
                          background: "#dbeafe",
                          padding: "2px 8px",
                          borderRadius: 4,
                          marginLeft: 8,
                        }}
                      >
                        Proposition du RU
                      </span>
                    </>
                  }
                />
              )}

              {/* Sanction alternative */}
              {alternativeProposal && (
                <ProposalOption
                  proposal={alternativeProposal}
                  isSelected={selectedProposalId === alternativeProposal.id}
                  onClick={() => onSelectProposal(alternativeProposal)}
                  label={
                    <>
                      Sanction{" "}
                      {alternativeProposal.id === "DEFAUT"
                        ? "par défaut"
                        : "modérée"}
                    </>
                  }
                />
              )}

              {/* Aucune sanction */}
              {noSanctionProposal && (
                <ProposalOption
                  proposal={noSanctionProposal}
                  isSelected={selectedProposalId === noSanctionProposal.id}
                  onClick={() => onSelectProposal(noSanctionProposal)}
                  label="Aucune sanction"
                  activeColor="#22c55e"
                  activeBg="linear-gradient(135deg, #f0fdf4, #dcfce7)"
                />
              )}
            </div>
          )}

          {/* Options commission */}
          {!isNoSanction && (
            <>
              <SectionHeader
                icon="fa-building"
                iconBg="#8b5cf6"
                title="Options spécifiques"
                subtitle="Radiations complémentaires"
              />
              <div className="d-flex flex-column mb-4" style={{ gap: 8 }}>
                <label
                  className="d-flex align-items-start p-3 rounded mb-0"
                  style={{
                    background: radiationBRSA ? "#fef3c7" : "#f8fafc",
                    border: radiationBRSA
                      ? "1px solid #fde68a"
                      : "1px solid #e2e8f0",
                    gap: 10,
                    cursor: isSuppression ? "not-allowed" : "pointer",
                    transition: "all 0.15s ease",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={radiationBRSA}
                    onChange={(e) => setRadiationBRSA(e.target.checked)}
                    disabled={isSuppression}
                    style={{
                      width: 18,
                      height: 18,
                      marginTop: 2,
                      accentColor: "#f59e0b",
                      cursor: isSuppression ? "not-allowed" : "pointer",
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#1e293b",
                      }}
                    >
                      Radiation BRSA
                    </div>
                    <div style={{ fontSize: 12, color: "#64748b" }}>
                      Radiation de la liste des BRSA, sauf si mise en conformité
                    </div>
                  </div>
                </label>
                <label
                  className="d-flex align-items-start p-3 rounded mb-0"
                  style={{
                    background: radiationDE ? "#fef3c7" : "#f8fafc",
                    border: radiationDE
                      ? "1px solid #fde68a"
                      : "1px solid #e2e8f0",
                    gap: 10,
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={radiationDE}
                    onChange={(e) => setRadiationDE(e.target.checked)}
                    style={{
                      width: 18,
                      height: 18,
                      marginTop: 2,
                      accentColor: "#f59e0b",
                      cursor: "pointer",
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#1e293b",
                      }}
                    >
                      Radiation DE
                    </div>
                    <div style={{ fontSize: 12, color: "#64748b" }}>
                      Radiation de la liste des demandeurs d'emploi pour la même
                      durée que la sanction sélectionnée
                    </div>
                  </div>
                </label>
              </div>
            </>
          )}

          {/* Note interne */}
          <SectionHeader
            icon="fa-sticky-note"
            iconBg="#64748b"
            title="Note interne"
            subtitle="Optionnelle — visible uniquement en interne"
          />
          <textarea
            className="form-control mb-1"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Ajouter un commentaire sur cette décision..."
            rows={3}
            style={{
              borderRadius: 8,
              border: "1px solid #e2e8f0",
              fontSize: 13,
            }}
          />
        </>
      ) : (
        /* Read-only view */
        <>
          <SectionHeader
            icon="fa-gavel"
            iconBg="#22c55e"
            title="Décision enregistrée"
          />
          {loadingBareme ? (
            <div
              className="d-flex align-items-center justify-content-center p-4 mb-4 rounded"
              style={{
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                gap: 10,
              }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 16, color: "#64748b" }}
              />
              <span style={{ fontSize: 14, color: "#64748b" }}>
                Chargement...
              </span>
            </div>
          ) : (
            <div
              className="p-4 rounded mb-4"
              style={{
                background: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
                border: "1px solid #86efac",
              }}
            >
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 800,
                  color: "#166534",
                }}
              >
                {inscription.decisionText || "Décision enregistrée"}
              </div>
            </div>
          )}
          {inscription.note && (
            <>
              <SectionHeader
                icon="fa-sticky-note"
                iconBg="#64748b"
                title="Note interne"
              />
              <div
                className="p-3 rounded"
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  fontSize: 13,
                  color: "#475569",
                  fontStyle: "italic",
                }}
              >
                {inscription.note}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DecisionModalDecision;
